import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { MyAlertProvider } from '../../providers/my-alert/my-alert';
import { WalletProvider } from '../../providers/wallet/wallet';
import {global, Global} from "../../environments/global";

/**
 * Generated class for the ContactWalletComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'contact-wallet',
  templateUrl: 'contact-wallet.html',
})
export class ContactWalletComponent implements OnChanges {
  public global: Global = global;

  text: string;

  @Input() contact;
  @Output() deleteContact = new EventEmitter();

  show_all_wallet: boolean;
  constructor(
    public myAlert: MyAlertProvider,
    public walletService: WalletProvider
  ) {}

  ngOnChanges(change: SimpleChanges) {
    if (change['contact']) {
    }
  }

  deleteWallet(contact, index?) {
    let alertObj = {
      type: 'confirm',
      title: '确认删除该用户的钱包地址么?',
      message:
        '删除用户地址后,地址不会恢复' +
        (contact.wallets.length == 1 ? ',该用户将进入无地址群友列表' : ''),
      success: {
        text: '删除',
        callback: () => {
          this.walletService.deleteAWallet(contact.address_list[index].id).subscribe(res =>{
            if (index) {
              contact.wallets.splice(index, 1);
            } else {
              contact.wallets.shift();
            }

            if (contact.wallets.length == 0) {
              this.deleteContact.emit(true);
            }
          })

        },
      },
      fail: {
        text: '取消',
      },
    };
    this.myAlert.showAlert(alertObj);
  }

  deleteItemWallet(contact){
    let alertObj = {
      type: 'confirm',
      title: '确认删除该用户的钱包地址么?',
      message:
      '删除用户地址后,地址不会恢复',
      success: {
        text: '删除',
        callback: () => {
          this.walletService.deleteAWallet(contact.id).subscribe(res =>{

            // if (contact.wallets.length == 0) {
              this.deleteContact.emit(true);
            // }

          })
        },
      },
      fail: {
        text: '取消',
      },
    };
    this.myAlert.showAlert(alertObj);
  }

  toggleAllWallet() {
    // this.walletService.updataAWallet()
    this.show_all_wallet = !this.show_all_wallet;
  }

  edit_wallet;
  editWallet(e, wallet) {
    this.edit_wallet = Object.assign({}, wallet);
    this.edit_wallet.coin_address = '';
    setTimeout(() =>{
      this.edit_wallet.coin_address = wallet.coin_address;
    },0)
  }

  enterChange(e, index?) {
    if (e.keyCode == 13) {
      this.saveWalletChange(index);
    }
  }

  saveWalletChange(index?) {
    if (
      this.edit_wallet.coin_address &&
      this.edit_wallet.coin_address !=
        this.contact.wallets[index ? index : 0].coin_address
    ) {
      let alertObj = {
        type: 'confirm',
        title:
          '确认修改该用户的钱包地址为' + this.edit_wallet.coin_address + '？',
        message: '修改用户地址后,地址不会恢复',
        success: {
          text: '修改',
          callback: () => {
            this.walletService
              .updataAWallet(
                this.edit_wallet.wallet_id,
                this.edit_wallet.coin_address
              )
              .subscribe(res => {
                this.contact.wallets[
                  index ? index : 0
                ].coin_address = this.edit_wallet.coin_address;
                this.edit_wallet = null;

                // let alertObj = {
                //   type:'alert',
                //   title:'修改成功',
                //   message:'修改用户的钱包地址成功',
                //   success:{
                //     text:'知道了',
                //   }
                // };
                // this.myAlert.showAlert(alertObj);
              });
          },
        },
        fail: {
          text: '取消',
          callback: () => {
            this.edit_wallet = null;
          },
        },
      };
      this.myAlert.showAlert(alertObj);
    } else {
      this.edit_wallet = null;
      // this.deleteWallet(this.contact,index);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/contact-wallet/contact-wallet.ts